import { render, staticRenderFns } from "./PageDistributor.vue?vue&type=template&id=71489bce&scoped=true"
import script from "./PageDistributor.vue?vue&type=script&lang=js"
export * from "./PageDistributor.vue?vue&type=script&lang=js"
import style0 from "./PageDistributor.vue?vue&type=style&index=0&id=71489bce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71489bce",
  null
  
)

export default component.exports